<template>
    <div v-if="config.hasUserFilterPresets">
        <v-btn
            icon
            large
            elevation="2"
            class="mx-1 always-elevated-btn"
            @click.stop="menu = true"
        >
            <v-icon medium class="filter-icon" :color="!!selectedPreset ? '#febf15' : (theming.cardsAndTablesText || 'black')">
                mdi-account-search-outline
            </v-icon>
        </v-btn>
        <v-dialog v-model="menu" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Επιλογή Φίλτρου</span>
                </v-card-title>
                <v-container v-if="userPresets.length" class="selection-container">
                    <v-select
                        v-model="selectedFilter"
                        class="selection"
                        :items="userPresets"
                        label="Φίλτρo"
                        item-text="name"
                        return-object
                        dense
                        outlined
                    ></v-select>
                    <v-btn
                        @click="showDeleteConfirm = true"
                        :disabled="!selectedFilter"
                        icon
                        large
                        elevation="2"
                        class="mx-1 always-elevated-btn white"
                    >
                        <v-icon medium class="filter-icon" color="red">
                            mdi-trash-can-outline
                        </v-icon>
                    </v-btn>
                </v-container>
                <v-container v-else class="selection-container">
                    <span class="mr-3 font-weight-bold">Δεν υπάρχουν αποθηκευμένα φίλτρα</span>
                </v-container>
                <div v-if="userPresets.length">
                    <v-card-actions v-if="!showDeleteConfirm" class="d-flex justify-center">
                        <v-btn class="mx-2 white--text" medium color="black" @click="applyFilter" :disabled="!selectedFilter">
                            <v-icon dark>mdi-filter-variant</v-icon> ΕΦΑΡΜΟΓΗ
                        </v-btn>
                        <v-btn class="mx-2 white--text" medium color="red" @click="menu = false; showDeleteConfirm = false">
                            ΑΚΥΡΩΣΗ
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-else class="d-flex justify-center align-center">
                        <span class="mr-3 font-weight-bold">Είστε σίγουροι;</span>
                        <v-btn class="mx-2 white--text" medium color="black" @click="deleteFilter">
                            ΝΑΙ
                        </v-btn>
                        <v-btn class="mx-2 white--text" medium color="red" @click="showDeleteConfirm = false">
                            ΟΧΙ
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import userFilterPresetService from '@/services/userFilterPreset'
    export default {
        name: 'FilterPreset',
        props: {
            userPresets: {
                type: Array,
                required: true
            },
            selectedPreset: {
                type: Object,
                required: false,
                default: () => null
            }
        },
        watch: {
            menu(newVal) {
                if (!newVal) {
                    this.showDeleteConfirm = false
                }
            },
            selectedPreset: {
                handler(newVal) {
                    this.selectedFilter = newVal
                },
                immediate: true,
                deep: true
            }
        },
        computed: {
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            }
        },
        data() {
            return {
                menu: false,
                selectedFilter: null,
                showDeleteConfirm: false
            }
        },
        methods: {
            applyFilter() {
                this.$emit('apply-filter', this.selectedFilter)
                this.menu = false
                this.selectedFilter = null
            },
            deleteFilter() {
                if (this.selectedFilter) {
                    userFilterPresetService.delete(this.selectedFilter.id).then(() => {
                        this.$emit('delete-filter', this.selectedFilter)
                    })
                }
                this.showDeleteConfirm = false
                this.selectedFilter = null
            }
        }
    }
</script>
<style scoped>
.filter-icon:hover {
    color: #febf15 !important;
}
.selection-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<style>
.selection .v-text-field__details {
    display: none !important;
}
</style>
